var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFrom = function SvgFrom(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1001 914.097C82.9001 832.497 114.4 773.297 137.9 736.197C294.9 487.797 585.8 449.497 628.2 447.997C630.5 447.897 641.6 447.597 658.3 446.897C663.1 446.697 668 446.497 672.9 446.297",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M569.5 914.1C563.5 906.2 476.4 771.5 530.8 620.5C553.7 556.9 594.3 514.3 629.9 487.2C636.2 482.2 644.9 476 655.9 469.9C658.7 468.3 661.5 466.9 664.3 465.5",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M474.7 542.502C479.4 539.102 484.2 535.702 489 532.602",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M365.4 644.7C367.6 641 369.8 637.3 372.1 633.7C378.7 623.3 385.5 613.4 392.7 604",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M292.6 912.398C291.3 884.698 291.2 834.398 306.4 775.398",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 596.297V487.297",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.4 537.6C210.845 537.6 241.2 507.245 241.2 469.8C241.2 432.355 210.845 402 173.4 402C135.955 402 105.6 432.355 105.6 469.8C105.6 507.245 135.955 537.6 173.4 537.6Z",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M351.7 470.103V393.703",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M351.7 428.997C377.989 428.997 399.3 407.686 399.3 381.397C399.3 355.108 377.989 333.797 351.7 333.797C325.411 333.797 304.1 355.108 304.1 381.397C304.1 407.686 325.411 428.997 351.7 428.997Z",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M801.9 919.203V705.103L746 644.703",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M801.9 803.9C875.464 803.9 935.1 744.264 935.1 670.7C935.1 597.136 875.464 537.5 801.9 537.5C728.336 537.5 668.7 597.136 668.7 670.7C668.7 744.264 728.336 803.9 801.9 803.9Z",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M779.5 680.998L839.6 603.898",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M648 516.9C672.6 419.4 710.7 387.9 739.9 376.7C801.7 352.9 867.7 402.7 900.8 367.5C920.4 346.6 909.7 315.6 942.2 282.5C953.9 270.6 966.2 263.5 974.4 259.5",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 225.5C132.1 197.5 206 174.2 248.7 207.1C275.1 227.4 266.9 251.5 294.7 271.4C342.7 305.8 392.5 252 490 266.8C514.6 270.6 548.5 285.4 616.4 315.1C662.5 335.3 700.1 354.1 726.7 368",
    strokeWidth: 29,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFrom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/icons/from.svg";